import React from 'react';
import { NextSeo } from 'next-seo';
import { termsContent } from '_constants/termsContent';

function Privacy() {
  return (
    <div className="privacy">
      <NextSeo title="Terms of Service" />
      <div className="top-banner">
        <div className="copy">
          <h1>Terms of Service</h1>
        </div>
      </div>

      <div className="text">
        <p>
          PLEASE READ THE TERMS AND CONDITIONS CAREFULLY BEFORE USING THIS
          WEBSITE. BY USING THIS WEBSITE YOU AGREE TO BE BOUND BY THESE TERMS
          AND CONDITIONS.
        </p>
        <p>
          This website, including all of its features and content, hereinafter
          referred to as ("Website") is a service made available by Trademark
          Genius hereinafter referred to as ("Provider") and all content,
          information, services ordered or provided on or through this Website,
          hereinafter referred to as ("Content") is to be used solely under the
          proceeding terms and conditions, hereinafter referred to as ("Terms of
          Use").
        </p>
        {termsContent.map((section, idx) => (
          <div key={idx} className="tag">
            <h4>{section.title}</h4>
            {section.body.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
            <hr />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Privacy;
